export class localStorageVariables{
  public static readonly LastCompletedStepPagenName= "LastCompletedStepPagenName";
  public static readonly ActiveStepPagename= "ActiveStepPagename";
  public static readonly MenuWorkflowStep = "MenuWorkflowStep"; // Tracks menu workflow progression (major milestones)
  public static readonly PropertyId="PropertyId";    
  public static readonly sitename= "sitename";
  public static readonly Property= "Property";
  public static readonly customtheme="customtheme";
  public static readonly PropertyBannerImageUrl= "PropertyBannerImageUrl";
  public static readonly PropertyLogoUrl= "PropertyLogoUrl";
  public static readonly SelectedUnitID="SelectedUnitID"
  public static readonly isOnlineLeasingIDVerifyEnabled="isOnlineLeasingIDVerifyEnabled"
  public static readonly IsScreeningEnabled="IsScreeningEnabled"
  public static readonly enableUploadID = "enableUploadID"
  public static readonly PropertyName="PropertyName"
  public static readonly SelectedMoveInDate="SelectedMoveInDate"
  public static readonly FloorPlanID="FloorPlanID"
  public static readonly FloorPlanName="FloorPlanName"

  public static readonly SelectedArea="SelectedArea"
  public static readonly SelectedAreaDisplay="SelectedAreaDisplay" 
  public static readonly SelectedUnitCode="SelectedUnitCode"
  public static readonly SelectedRoomCode="SelectedRoomCode"
  public static readonly PrimaryApplicantId="PrimaryApplicantId"
  public static readonly isPrimaryApplicantLogin="isPrimaryApplicantLogin"
  public static readonly LoginApplicantId="LoginApplicantId"
  public static readonly lastUrlBeforeLogin="lastUrlBeforeLogin"
  public static readonly workflowStep="workflowStep"
  public static readonly Profiles="Profiles"
  public static readonly AccountsCallingSource="AccountsCallingSource"
  public static readonly TemplastUrlBeforeLogin="TemplastUrlBeforeLogin"
  public static readonly ElevateSession="ElevateSession"
  public static readonly TemplateId="TemplateId"
  public static readonly IsApplyByUnit="IsApplyByUnit"
  public static readonly EncPropertyId = "EncPropertyId"
  public static readonly EncProspectId = "EncProspectId"
  public static readonly EncPmUserExId = "EncPmUserExId"
  public static readonly EncPrimaryProspectId = "EncPrimaryProspectId"
  public static readonly IDVerificationStepLocaltion = "IDVerificationStepLocaltion"
  public static readonly NextStepPagename = "NextStepPagename"
  public static readonly SelGradeName ="SelGradeName"
  public static readonly PreviousStepPagename = "PreviousStepPagename"
  public static readonly IsRMMEnabled ="IsRMMEnabled"
  public static readonly LoginServiceHandlingNavigation = "LoginServiceHandlingNavigation"
  public static readonly CachedThemeCSS = "CachedThemeCSS";
  public static readonly CachedThemeCSSExpiry = "CachedThemeCSSExpiry";
  public static readonly SCOLESessionHasExpiredCookieKey = "SCOLESessionHasExpired";
  public static readonly UserPreferredLanguage = "user-preferred-language";
  public static readonly CachedNotifications = "CachedNotifications";

}
